import styled from 'styled-components';
import { IMG } from 'conversations-internal-schema/file-metadata/constants/fileAttachmentTypes';
import { useImageLightbox } from 'conversations-visitor-experience-components/lightbox/ImageLightboxContext';
import FileAttachmentCard from './file/FileAttachmentCard';
import ImageAttachmentCard from './ImageAttachmentCard';
import MovieAttachmentCard from './MovieAttachmentCard';
import { MOVIE_ATTACHMENT_TYPE } from './constants';
import buildGalleryItems from './buildGalleryItems';
import MediaGallery from './MediaGallery';
import toLightboxImages from './utils/toLightboxImages';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FileAttachmentList = styled.div.withConfig({
  displayName: "AttachmentCard__FileAttachmentList"
})(["display:flex;flex-direction:column;gap:", ";"], ({
  theme
}) => theme.spotlight.spacing.xs);
const AttachmentCard = ({
  fileAttachments
}) => {
  const {
    openLightbox
  } = useImageLightbox();
  if (!(fileAttachments !== null && fileAttachments !== void 0 && fileAttachments.length)) {
    return null;
  }
  const {
    images,
    movies,
    files
  } = fileAttachments.reduce((acc, attachment) => {
    if (attachment.type === IMG) {
      acc.images.push(attachment);
    } else if (attachment.type === MOVIE_ATTACHMENT_TYPE) {
      acc.movies.push(attachment);
    } else {
      acc.files.push(attachment);
    }
    return acc;
  }, {
    images: [],
    movies: [],
    files: []
  });
  const lightboxImages = toLightboxImages(images);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [images.length === 1 ? /*#__PURE__*/_jsx(ImageAttachmentCard, {
      fileMetadata: images[0],
      onPress: () => openLightbox(lightboxImages, 0)
    }) : images.length > 1 ? /*#__PURE__*/_jsx(MediaGallery, {
      items: buildGalleryItems(images),
      onImagePress: index => openLightbox(lightboxImages, index)
    }) : null, movies.map(fileAttachment => /*#__PURE__*/_jsx(MovieAttachmentCard, {
      fileMetadata: fileAttachment
    }, fileAttachment.url)), files.length > 0 && /*#__PURE__*/_jsx(FileAttachmentList, {
      children: files.map(fileAttachment => /*#__PURE__*/_jsx(FileAttachmentCard, {
        fileMetadata: fileAttachment
      }, fileAttachment.url))
    })]
  });
};
AttachmentCard.displayName = 'AttachmentCard';
export default AttachmentCard;